/**
 * Boot (01): the player shell, the GL core and HUD, the bundle loader and the one view.
 * See `app/player.ts`.
 */
import './app/shell.css';
import { Player } from './app/player.ts';
import { VERSION, VERSION_LABEL } from './version.ts';

document.documentElement.dataset.version = VERSION;
console.info(`undercut ${VERSION_LABEL}`);

function byId<T extends HTMLElement>(id: string, ctor: new () => T): T {
  const el = document.getElementById(id);
  if (!(el instanceof ctor)) throw new Error(`#${id} missing or not a ${ctor.name}`);
  return el;
}

const player = new Player({
  app: byId('app', HTMLDivElement),
  stage: byId('stage', HTMLDivElement),
  gl: byId('gl', HTMLCanvasElement),
  hud: byId('hud', HTMLCanvasElement),
});

player.boot().catch((e: unknown) => {
  console.error('undercut: boot failed', e);
  document.documentElement.dataset.ready = 'error';
});
